import React from 'react';
import './Title.css';

const Title: React.FC = () => {
    return (
        <div className="div-title">
            <img src="/suited/favicon.ico" alt="s" className="title-icon"/>
            <div>
                Suited
                <br />
                A Bridge Auction Brain Bender
            </div>
        </div>
    );
};

export default Title;